import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class BlankIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"/>
        )
    }
}

export default withCssClassName(BlankIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/blank-icon.js